import React,{useState,useEffect,useContext} from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { ToastContainer, toast } from "react-toastify";
import { ManagerAuthContext } from "../context/AuthManager";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

export const UsersList = () => {
  
  const { currentUserRF } = useContext(ManagerAuthContext);

  const [name,setName] = useState('')
  const [meli,setMeli] = useState('')
  const [year,setYear] = useState('')
  const [month,setMonth] = useState('')
  const [day,setDay] = useState('')
  const [io1,setIo1] = useState('')
  const [io2,setIo2] = useState('')
  const [password,setPassword] = useState('')
  const [tel,setTel] = useState('')

  const RegisterStudent = async () =>{
 
     try{
      if(!name ||!tel || !io1 || !io2){
        toast.warning("لطفا تمامی موارد خواسته شده را پر نمائید")
      }else{
       
    await axios.post("https://clinic.salamatpayanew.ir/Register/register",{
      name:name,
      meli:meli,
      year:year,
      month:month,
      day:day,
      io1:io1,
      io2:io2,
      password:password,
      tel:tel
    })
    toast.success("عملیات ثبت نام با موفقیت انجام شد - منتظر تایید مدیر بمانید")
  }
  }catch(e){
    toast.error("خطا در ایجاد دانش آموز جدید")
  } 
}

const [userList, setUserList] = useState([]);

useEffect(() => {
  const getAllProductsRT = async () => {
    // personal Read
    const res = await fetch(
      'https://clinic.salamatpayanew.ir/Register/UserList'
    );
    setUserList(await res.json());
  };
  getAllProductsRT();
}, []);

const [showb, setShowb] = useState(false);
const handleCloseb = () => setShowb(false);
const handleShowb = () => setShowb(true);

const [getID,setGetId] = useState('')
const [family,setFamily] = useState('')

const showPopup = (id,famil) =>{
    setGetId(id)
    setFamily(famil)
    handleShowb(true)
}

const handleDelete = (id) => {
    axios
      .delete(
        `https://clinic.salamatpayanew.ir/Register/DeleteUser/${id}`
      )
      .then((response) => {
        setUserList((values) => {
          return values.filter((item) => item.id !== id);
        });

        toast.success("حذف  با موفقیت انجام شد");
      });
  };

const updateActive = async(code) => {
    try{
    await axios
      .put(
        `https://clinic.salamatpayanew.ir/StudentUpdate/Active/${code}`,
        {
            type: '2',
            stat:'تایید شده'
        }
      )
      .then(() => {
        toast.success("فعال سازی  با موفقیت انجام شد");
      })
      .catch(() => {
        toast.error("خطا در فعال سازی کاربر ");
      });
    }catch(e){
        toast.error("خطا در عملیات")
    }
}

const updateDeActive = async(code) => {
    try{
    await axios
    .put(
      `https://clinic.salamatpayanew.ir/StudentUpdate/DeActive/${code}`,
      {
            type: '1',
             stat:'عدم تایید'
      }
    )
    .then(() => {
      toast.success("غیر فعال سازی  با موفقیت انجام شد");
    })
    .catch(() => {
      toast.error("خطا در غیر فعال سازی ");
    });
    }catch(e){
        toast.error("خطا در عملیات")
    }
}

  if (currentUserRF.meli === null) {
     } else {
  return (
   <>
   <section class="m-0 content" dir='rtl'>
            <div class="d-flex flex-column justify-content-start align-items-center">
                <div class="card">
                    <img src="../img/dr02.png" class="position-absolute form-img" alt="" />
                    <div class="d-flex flex-column justify-content-start card-title-container">
                        <div class="card-title text-secondary"> کاربر جدید</div>
                        <p class="card-subtitle">جهت افزودن کاربر جدید فرم زیر را تکمیل نمایید</p>
                    </div>
                    <div class="d-flex flex-column flex-md-row justify-content-between w-100 t-24">
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2" placeholder="نام و نام خانوادگی" onChange={(e) => setName(e.target.value)} />
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 mx-md-3">
                            <select class="form-select form-control pr-16 my-2" aria-label="Default select example" onChange={(e) => setIo1(e.target.value)}>
                                <option selected>مقطع تحصیلی</option>
                                <option value="هشتم">هشتم</option>
                                <option value="نهم">نهم</option>
                                <option value="دهم">دهم</option>
                                <option value="یازدهم">یازدهم</option>
                                <option value="دوازدهم">دوازدهم</option>
                                <option value="فارغ التحصیل">فارغ التحصیل</option>
                            </select>
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0">
                            <select class="form-select form-control pr-16 my-2" aria-label="Default select example" onChange={(e) => setIo2(e.target.value)}>
                                <option selected>رشته</option>
                                <option value="ریاضی">ریاضی</option>
                                <option value="علوم تجربی">علوم تجربی</option>
                                <option value="علوم انسانی">علوم انسانی</option>
                                <option value="زبان خارجی">زبان خارجی</option>
                                <option value="هنر">هنر</option>
                                <option value="سایر">سایر</option>
                            </select>
                        </div>
                        <div class="custom-form-control form-group position-relative w-30 ms-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="روز" onChange={(e) => setDay(e.target.value)}/>
                        </div>
                        <div class="custom-form-control form-group position-relative w-30 ms-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="ماه" onChange={(e) => setMonth(e.target.value)}/>
                        </div>
                        <div class="custom-form-control form-group position-relative w-30 ms-md-3">
                            <input type="text" class="form-control pr-16 my-2" placeholder="سال" onChange={(e) => setYear(e.target.value)}/>
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                        <div class="custom-form-control form-group position-relative w-50">
                            <input type="text" class="form-control pr-16 my-2" maxLength={11} placeholder="شماره موبایل" onChange={(e) => setTel(e.target.value)}/>
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 ms-md-3">
                        <input type="text" class="form-control pr-16 my-2" maxLength={10} placeholder="کد ملی" onChange={(e) => setMeli(e.target.value)}/>
                        </div>
                        <div class="custom-form-control form-group position-relative w-50 m-0 ms-md-3">
                            <input type="password" class="form-control pr-16 my-2" maxLength={12} placeholder="رمز عبور"onChange={(e) => setPassword(e.target.value)}setPassword />
                        </div>
                    </div>
                    <button class="custom-btn-primary t-24 form-submit p-16" onClick={RegisterStudent}>
                        ثبت نام کاربر جدید </button>
                </div>
            </div>
        </section>

        <section class="m-0 content" dir='rtl'>
            <div class="row">
                <h1 class="page-title text-secondary text-start w-100">کاربران سایت</h1>
                <div class="table-responsive">
                    <table class="table bg-white custom-rounded t-24 table-responsive">
                        <thead>
                            <tr class="text-center">
                               <th><span>عکس کاربر</span></th>
                                <th><span>نام و نام خانوادگی</span></th>
                                <th><span>شماره تماس</span></th>
                                <th><span>مقطع تحصیلی</span></th>
                                <th><span>رشته</span></th>
                                <th><span>وضعیت</span></th>
                                <th><span>عملیات</span></th>
                            </tr>
                        </thead>
                        {userList.map((item) => {
                        const {
                          id,name,tel,io1,io2,year,day,month,stat
                        } = item;
                        return (
                        <tbody class="text-center" key={item.id}>
                            <tr>
                                <td class="fw-bold">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <img src="../img/Avatar-Image.png" class="rounded-circle" width="50"
                                            alt="" />
                                       </div>
                                </td>
                                <td>
                                <div class="d-flex flex-column justify-content-start align-items-start mr-16 text-right">
                                            <p class="mb-0">{item.name}</p>
                                        </div>
                                </td>
                                <td>{item.tel}</td>
                                <td>{item.io1}</td>
                                <td>{item.io2}</td>
                                <td><span class="tags">{item.stat}</span></td>
                                <td> <button type="button" class="action-tag" data-toggle="modal"
                                        data-target="#Removemodal" onClick={() => handleDelete(id)}>
                                        حذف
                                    </button></td>

                                    <td>
                                    <td>
                                    <button onClick={() => showPopup(id,name)}
                                          class="btn btn-primary power-button m-auto position-relative overflow-hidden h-auto d-flex justify-content-center align-items-center">
                                        <i class="zmdi  zmdi-pin-assistant text-white"></i>
                                          <div class="reple position-absolute"></div>
                                        </button>
                                    </td>
                                    </td>
                            </tr>
                        </tbody>
              );
            })}
                    </table>

                </div>
            </div>
        </section>

       <ToastContainer
        position="top-center"
        autoClose={20000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />


<Modal show={showb} onHide={handleCloseb} className=''>
        <Modal.Body>
        <div id="Removemodal" tabindex="-1" role="dialog"
                                    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-centered" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header text-center border-0 p-0">
                                                <img src="../img/remove.png" class="m-auto" alt="" />
                                            </div>
                                            <div class="modal-body text-center border-0 p-0 border-end-0">
                                                <h3>{family}</h3>
                                                <p class="t-16">
                                                    آیا می خواهید وضعیت <span style={{color:"red"}}>{family}</span> را فعال یا غیر فعال نمائید 
                                                </p>
                                                   
                                            </div>
                   
                                        </div>
                                    </div>
          </div>
        </Modal.Body>

        <div class="modal-footer flex-row-reverse border-0 w-100 justify-content-center p-0" dir='rtl'>
                    <button type="button" class="btn btn-danger d-inline-block" onClick={() => updateDeActive(getID)}>
                     غیر فعال</button>
                      <button type="button" class="btn btn-primary d-inline-block" onClick={() => updateActive(getID)}>
                     فعال</button>
                  </div>

      </Modal>

   </>
  )
}

}